import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import { environment } from 'src/environments/environment';
import { DoctorServiceService } from '../api-services/doctor-service.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { compareAsc, format, isDate, parseISO } from 'date-fns'
import Swal from 'sweetalert2';
import { ViewportScroller } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from '../api-services/Auth/auth.service';
import { MustMatch } from './passwordMatch';
/**
 * This component is for doctor registration.Doctor should be provide his/her information
 * like name address education details and creditanal upload files for registration.
 */
@Component({
  selector: 'app-doctor-registration',
  templateUrl: './doctor-registration.component.html',
  styleUrls: ['./doctor-registration.component.css']
})
export class DoctorRegistrationComponent implements OnInit {
  @ViewChild('msg') modalRef;
  backendUrl = `${environment.restAPIUrl}/api/public`
  emailRegx = new RegExp("^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$");
  genders: any;
  countries: any;
  doctorRegistrationForm: FormGroup;
  states: any;
  cities: any;
  zipcodes: any;
  showEmail: boolean = false;
  showDisabled: boolean = false;
  educations: any[] = [];
  formErrors: any = {
    data: '',
    bool: false
  };
  specaiality_list: any;
  languageList: any;
  ddSettingsToSpeak: IDropdownSettings;
  ddSettingsToSW: IDropdownSettings;
  ddSettingToSpecilities: IDropdownSettings;
  todayDate = new Date();
  startAt: Date;
  endAt: Date;
  uploadFiles: any = [];
  checkTime: boolean;
  IdProof: any;
  profileUpload: any;
  getAllFiles: any = [
    {
      credentialType: "ID Proof",
      documentIds: []
    },
    {
      credentialType: "Profile Photo",
      documentIds: []
    },
    {
      credentialType: "Address Proof",
      documentIds: []
    },
    {
      credentialType: "State Registration Certificate",
      documentIds: []
    },
    {
      credentialType: "Undergraduate Certificate",
      documentIds: []
    },
    {
      credentialType: "Postgraduate Certificate",
      documentIds: []
    },
  ]
  addressProof: any;
  stateCertProof: any;
  under: any;
  post: any;
  acceptFilesFormat = ".pdf,.doc,.docx,.jpeg,.jpg,.png"
  unsupportFiles: any = [];
  getTime: any;
  getTime1: any;
  maxdate: Date;
  setTimings: FormGroup
  getReq: any;
  constructor(private doctor_service: DoctorServiceService, private modalService: BsModalService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private scroller: ViewportScroller,
    private authService: AuthService,) { }

  ngOnInit() {
    let date = new Date();
    this.maxdate = new Date(`${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear() - 18}`);
    const roundToHalf = date => new Date(Math.ceil(date / (1000 * 60 * 30)) * (1000 * 60 * 30))
    this.todayDate = roundToHalf(new Date)
    this.startAt = new Date(new Date().setHours(4, 0, 0));
    this.endAt = new Date(new Date().setHours(23, 0, 0));
    this.getTime = this.startAt;
    this.getTime1 = this.startAt;
    this.setTimings = new FormGroup({
      startTime: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required]),
    }, {
      validators: (control) => {
        if (control.value.startTime && control.value.endTime) {
          let startTime = format(this.setTimings.get('startTime').value, 'HH');
          let endTime = format(this.setTimings.get('endTime').value, 'HH');
          if (startTime >= endTime) {
            control.get("startTime").setErrors({ greaterValue: true })
          } else {
            control.get("startTime").setErrors(null)
          }
        }
        return null
      }
    })

    this.doctorRegistrationForm = new FormGroup({
      firstName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(30), Validators.pattern('^[a-zA-Z \-\']+')]),
      lastName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(30), Validators.pattern('^[a-zA-Z \-\']+')]),
      email: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      confirmPassword: new FormControl('', [Validators.required]),
      mobile: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
      dob: new FormControl('', [Validators.required]),
      genderId: new FormControl('', [Validators.required]),
      addrLine1: new FormControl('', [Validators.required]),
      addrLine2: new FormControl('', []),
      availabilityStartTime: new FormControl('', [Validators.required]),
      availabilityEndTime: new FormControl('', [Validators.required]),
      languagesKnownSpeak: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      languagesKnownReadWrite: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      doctorSpecialities: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      //subspeciality: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      graduatedegree: new FormControl('', [Validators.required]),
      graduatecollege: new FormControl('', [Validators.required]),
      postgraduatedegree: new FormControl('', []),
      postgraduatecollege: new FormControl('', []),
      othercertification: new FormControl('', []),
      othercertificationcollege: new FormControl('', []),
      experienceFrom: new FormControl('', []),
      country: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      zip: new FormControl('', [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
      credentials: new FormControl()
    
    },this.matchPassword
    );


    //getSpecialities list api call
    this.doctor_service.getSpecilities().subscribe((data: any) => {
      this.specaiality_list = data;
    });
    this.doctor_service.getLanguagesList().subscribe(data => {
      this.languageList = data;
    });
    this.doctor_service.getGender().subscribe((data: any) => this.genders = data);
    this.doctor_service.getCountry().subscribe((data: any) => this.countries = data);

    this.ddSettingsToSpeak = {
      singleSelection: false,
      idField: 'id',
      textField: 'languageName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      // itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.ddSettingsToSW = {
      singleSelection: false,
      idField: 'id',
      textField: 'languageName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };
    this.ddSettingToSpecilities = {
      singleSelection: false,
      idField: 'id',
      textField: 'specialityName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };

  }

 
  /**
   * This method using to checking user/email id exit or not while email entering 
   */

  emailValidation() {
    if (this.emailRegx.test(this.doctorRegistrationForm.get('email').value)) {
      let emailReq = {
        email: this.doctorRegistrationForm.get('email').value
      }
      this.authService.check_userValid(emailReq).subscribe((res: any) => {
        this.getReq = res;
       
      }, err => {
        if (err.status == '409') {
          this.getReq = err.error;
          this.doctorRegistrationForm.get('email').setErrors({ exist: true });
          this.doctorRegistrationForm.get('email').updateValueAndValidity;
         
        }
      })
    }

  }


  private matchPassword(AC: AbstractControl) {
    let password = AC.get('password').value;
    if (AC.get('confirmPassword').touched || AC.get('confirmPassword').dirty) {
      let verifyPassword = AC.get('confirmPassword').value;
      if (password != verifyPassword) {
        AC.get('confirmPassword').setErrors({ matchPassword: true });
      } else {
        return null;
      }
    }
  }

  get f() {
    return this.doctorRegistrationForm.controls;
  }
  /**
   * This method to show user select country related state list 
   * @param CountryId This parameter refer to get user selected country id
   */
  getState(CountryId: any) {

    this.doctor_service.getState(CountryId.target.value).subscribe(data => {
      this.states = data
    });
  }
  getCity(StateId: any) {
    this.doctor_service.getCity(StateId.target.value).subscribe(data => this.cities = data);
  }
  getZipCode(CityId: any) {
    this.doctor_service.getZipCode(CityId).subscribe(data => this.zipcodes = data);
  }


/**
 * onSubmit method to get information of doctor and submitted to regitration api.
 * In this method to check required fields are vaild or not.
 * If not to show validation messages to user.
 */
  public onSubmit() {
    delete this.doctorRegistrationForm.value.confirmpassword;
  
    if (!this.doctorRegistrationForm.valid || !this.setTimings.valid) {
      this.doctorRegistrationForm.markAllAsTouched();
      this.setTimings.markAllAsTouched();
      this.scroller.scrollToAnchor('scrollForError');
      console.log("this.doctorRegistrationForm1",this.doctorRegistrationForm.value);
      console.log("this.doctorRegistrationForm.valid",this.doctorRegistrationForm.valid);
      console.log("this.setTimings.valid",this.setTimings.valid);
    } else if (this.doctorRegistrationForm.valid && this.setTimings.valid) {
      let newForm = JSON.parse(JSON.stringify(this.doctorRegistrationForm.value));
      console.log("this.doctorRegistrationForm2",newForm)
      delete newForm.confirmPassword;
      console.log("new form3",newForm);
      this.doctorRegistrationForm.get('credentials').patchValue(this.getAllFiles);
      //console.log("this.doctorRegistrationForm3",JSON.stringify(formCopy))
      this.doctor_service.registerDoctor(newForm).subscribe((data: any) => {
        if (data.status) {
          this.formErrors['bool'] = false;
          this.modalService.show(this.modalRef, {
            backdrop: 'static',
            keyboard: false,
            initialState: {
              message: data.message
            }
          });
        } else {
          this.formErrors['bool'] = false;
          this.modalService.show(this.modalRef, {
            class: 'modal-lg',
            backdrop: 'static',
            keyboard: false,
            initialState: {
              message: data.message
            }
          });
        }
      }, (err: any) => {
        if (err.status === 400) {
          this.formErrors['data'] = err.error.data;
          this.formErrors['bool'] = err.error.error;
          this.scroller.scrollToAnchor('forExitEmail');
        }
      });
    }
  };

  

  changeTime(str) {
    if (str == 'availabilityStartTime') {
      this.getTime = this.setTimings.get('startTime').value;
      let startTime = format(this.setTimings.get('startTime').value, 'HH');
      this.doctorRegistrationForm.get('availabilityStartTime').patchValue(startTime)
    } else {
      this.getTime1 = this.setTimings.get('endTime').value;
      let endTime = format(this.setTimings.get('endTime').value, 'HH');
      this.doctorRegistrationForm.get('availabilityEndTime').patchValue(endTime);
    }


  }


  resetForm() {
    this.doctorRegistrationForm.reset();
    this.setTimings.reset();
    this.getTime = this.startAt;
    this.getTime1 = this.startAt;
    this.scroller.scrollToAnchor('scrollForError');
  }

  /**
   * This method for accessing user selected file pushing to belong category type 
   * and validate file size ,file extension format.
   * @param str This str parameter is refer to categroy type e.g profile photo,address proof 
   * @param event Event parameter refer to get the target files information.
   */

  selectedFiles(str, event) {
    let formData = new FormData();
    let k = (this.getAllFiles[1]?.credentialType == str && this.getAllFiles[1]?.credentialType < 1) ? true : false


    if (event.target.files.length) {
      for (let file in event.target.files) {
        if (!isNaN(Number(file))) {
          let currentFile = event.target.files[file]
          let fileExtension = currentFile.name.substring(currentFile.name.lastIndexOf(".")).toLowerCase();
          let acceptedFilesArray = this.acceptFilesFormat.toLowerCase().split(",");
          if (acceptedFilesArray.indexOf(".") === -1 && acceptedFilesArray.indexOf(fileExtension) === -1) {
            Swal.fire({
              title: `Unsupported File`,
              icon: 'info',
            })
          } else if (currentFile.size > 2097152) {
            Swal.fire({
              title: `Upload file size should not exceed 2MB `,
              icon: 'info',
            })
          } else {
            if (this.getAllFiles[1]?.credentialType == str && this.getAllFiles[1]?.documentIds < 1) {
              this.uploadFiles.push(event.target.files[file])
            } else if (this.getAllFiles[1]?.credentialType != str) {
              this.uploadFiles.push(event.target.files[file])
            } else {
              return false
            }

          }
        }
      };
      for (let file in this.uploadFiles) {
        formData.append('files', this.uploadFiles[file]);
      }
      this.doctor_service.uploadFiles(formData).subscribe((res: any) => {
        this.uploadFiles = []
        formData.delete('files');
        if (res.length > 0) {
          this.getAllFiles.forEach((ele) => {
            if (ele.credentialType == str) {
              let joinArr = ele.documentIds.concat(res)
              let removeDuplicates = new Set(joinArr)
              ele.documentIds = [...removeDuplicates];
            }
          });
        };
      })
    }
  };
/**
 * This method is to remove user selected file
 * @param type This type refer which categroy files should be delete.
 * @param fileId To get file information
 */
  removeFileById(type, fileId) {
    this.getAllFiles.forEach(ele => {
      if (ele.credentialType === type && ele.documentIds.length > 0) {
        let index = ele.documentIds.indexOf(fileId);
        if (index > -1) {
          ele.documentIds.splice(index, 1)
        }
        return ele.documentIds
      }
    });
  }


  modalClose() {
    this.modalService.config.initialState = "";
    this.modalService.hide();
    this.router.navigate(['login'])
  }
}

